export default __webpack_public_path__ + "static/media/cyber-security-award.2b5711ab.png";